import React, { useState, useEffect } from "react";
import Navigation from "./router";
import AuthContext from "./components/auth-context";
import Cookies from "js-cookie";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const user = Cookies.get("sambauser");

    if (user) {
      setLoggedIn(true);
    }
  }, []);
  return (
    <AuthContext.Provider value={{ loggedIn, setLoggedIn }}>
      <Navigation />
    </AuthContext.Provider>
  );
}

export default App;
